// 🔧 auction_generator.js
// ✅ Purpose: Generates Silent Auction demo data
// ✅ Features:
// - Generates realistic auction items
// - Scales item count by demo size
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildAuctionDefaults } from "./templates/auction_defaults";
import { getEntryImageUrls } from "../../../utils/entry_images";

export const generateAuction = ({ demoContext } = {}) => {
  console.log("🔨 Auction Generator started.");

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  const demoSize =
    demoContext?.demoConfig?.size ||
    demoContext?.seedProfile?.demoSize ||
    "medium";

  const items = buildAuctionDefaults({
    industryTemplate,
    demoSize,
  });

  const users = (demoContext?.users || []).filter((user) => user?.id && user?.email);
  const entries = demoContext?.entries || [];

  entries.slice(0, 2).forEach((entry, index) => {
    if (!items[index]) return;
    items[index] = {
      ...items[index], sourceType: "entry", linkedEntryId: entry.id,
      linkedEntryCollection: "cars", linkedEntryLabel: entry.title || "Demo Entry",
      title: `${entry.title || "Demo Entry"} Experience Package`,
      imageUrl: getEntryImageUrls(entry)[0] || items[index].imageUrl,
      imageUrls: getEntryImageUrls(entry),
    };
  });

  const bidders = users.length
    ? users
    : [{ id: "demo-bidder", displayName: "Demo Bidder", email: "demo@example.com" }];
  const bids = [];
  items.filter((item) => item.status !== "draft").forEach((item, itemIndex) => {
    const bidTotal = item.status === "closed" ? Math.max(3, item.quantityAvailable + 1) : 2;
    for (let bidIndex = 0; bidIndex < bidTotal; bidIndex += 1) {
      // Make the Demo creator (first user) a visible winner on every closed lot.
      const bidder = item.status === "closed" && bidIndex === bidTotal - 1
        ? bidders[0]
        : bidders[(itemIndex + bidIndex) % bidders.length];
      const bidderNumber = bidders.findIndex((candidate) => candidate.id === bidder.id) + 1;
      bids.push({
        itemDemoKey: item.demoKey,
        bidderUid: bidder.id,
        bidderName: bidder.displayName || `${bidder.firstName || "Demo"} ${bidder.lastName || "Bidder"}`.trim(),
        bidderEmail: bidder.email,
        bidderCode: `BID-D${String(bidderNumber).padStart(3, "0")}`,
        amountCents: item.startingBidCents + (item.minimumIncrementCents * bidIndex),
        sequence: bidIndex + 1,
        demoSeed: true,
      });
    }
  });

  console.log("✅ Auction Generator completed.", {
    items: items.length,
    industryTemplate,
    demoSize,
  });

  return { items, bids };
};
